var map = {
	"./capital-blank-03_a.jpg": 6840,
	"./capital-m-03_a.jpg": 6659,
	"./capital-o-03_a.jpg": 3614,
	"./portrait-capital-blank-03_a.jpg": 6773,
	"./portrait-capital-m-03_a.jpg": 1153,
	"./portrait-capital-o-03_a.jpg": 1837,
	"./portrait-titles-back-cover-03_a.jpg": 3263,
	"./portrait-titles-front-cover-03_a.jpg": 6183,
	"./square-capital-a-03_a.jpg": 8024,
	"./square-capital-blank-03_a.jpg": 2977,
	"./square-capital-k-03_a.jpg": 5984,
	"./square-capital-m-03_a.jpg": 8178,
	"./square-capital-o-03_a.jpg": 8639,
	"./titles-back-cover-03_a.jpg": 1920,
	"./titles-front-cover-03_a.jpg": 2560
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8878;